import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  data() {
    return {
      index: 0,
      action: uploadFile,
      previewVisible: false,
      type: '',
      fileList: [],
      dataFrom: {
        photo: []
      }
    };
  },
  computed: {
    dataRule() {
      return {
        code: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('零配件编码')
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('配件名称')
        }],
        price: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('价格')
        }],
        opinion: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('门店意见')
        }]
        // photo:[{required: true, trigger: 'change', message: '请上传配件照片' ,type: 'array'}]
      };
    }
  },
  methods: {
    init(val, id, index, type) {
      if (val) {
        this.fileList = [];
        this.dataFrom = recursionCopy(val);
        val.photo.map((item, index) => {
          console.log(item);
          let name = item.substring(item.lastIndexOf('/') + 1, item.lastIndexOf('.'));
          let format = item.substring(item.lastIndexOf('.')).toLowerCase();
          this.fileList.push({
            status: 'done',
            uid: index + 1,
            url: item,
            format: format.slice(1),
            name: name + format
          });
        });
      } else {
        this.dataFrom.id = id;
        this.fileList = [];
      }
      console.log(this.fileList);
      this.index = index;
      this.type = type;
      this.previewVisible = true;
    },
    handleChange({
      file,
      fileList
    }, index) {
      console.log(fileList, file);
      // const isThanMax = file.size / 1024 / 1024 < 50;
      // if (!isThanMax) {
      //   return this.$message.error('文件最大不超50M');
      // }
      if (file.status === 'done') {
        if (file.response.code != 200) {
          this.$message.error(file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      this.dataFrom.photo = [];
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
          this.dataFrom.photo.push(file.url);
        } else if (file.status == 'done') {
          this.dataFrom.photo.push(file.url);
        }
        return file;
      });
      console.log(this.dataFrom.photo);
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.$emit('tableOk', this.dataFrom, this.index);
          this.$emit('cancel');
        }
      });
    }
  }
};